import { graphql } from "@/lib/gql/__generated__";

export const Hotel_DesignPage_Query = graphql(`
	query HotelEdit_DesignPage($hotelID: ID!) {
		hotel(hotelID: $hotelID) {
			id
			companyID
			hotelID
			name
			mainKeyVisual {
				bucket
				key
				region
				mimeType
				fileName
			}
			tags
			tagsLocation
			article {
				bucket
				key
				region
				mimeType
				fileName
			}
		}
	}
`);
